require.register("app/ui/form/SupplierSelect", function(exports, require, module){
  $0
  
});

